import { render, staticRenderFns } from "./modal-tramitacaoorcamento.vue?vue&type=template&id=f1ff35b2"
import script from "./modal-tramitacaoorcamento.vue?vue&type=script&lang=js"
export * from "./modal-tramitacaoorcamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports